/*
 * «Профиль на сервере» из меню сервера: ник и аватар, которые видны только здесь. Сама форма
 * общая со своим профилем, открытым с сервера (ServerProfileForm).
 */
import { Modal } from '@/components/settings/Modal'
import { ServerProfileForm } from './ServerProfileForm'

export function MemberProfileModal({ guildId, guildName, onClose }: { guildId: string; guildName: string; onClose: () => void }) {
  return (
    <Modal title={`Профиль на сервере «${guildName}»`} onClose={onClose} width={480}>
      <ServerProfileForm guildId={guildId} onLeave={onClose} />
    </Modal>
  )
}
